export enum ProjectStatuses {
  /**
   * Выигран
   */
  WON = 'won',

  /**
   * Проигран
   */
  FAILED = 'failed',

  /**
   * Создан
   */
  CREATED = 'created',

  /**
   * Идентификация
   */
  IDENTIFICATION = 'identification',

  /**
   * Исполнение
   */
  EXECUTION = 'execution',

  /**
   * Подтверждение
   */
  CONFIRMATION = 'confirmation',

  /**
   * Закрыто
   */
  CLOSED = 'closed',

  /**
   * Квалификация
   */
  QUALIFICATION = 'qualification',
}

export const ProjectStatusesTranslate: Record<string, string> = {
  [ProjectStatuses.WON]: 'Выиграно',
  [ProjectStatuses.FAILED]: 'Проиграно',
  [ProjectStatuses.IDENTIFICATION]: 'Идентификация',
  [ProjectStatuses.EXECUTION]: 'Исполнение',
  [ProjectStatuses.CONFIRMATION]: 'Подтверждение',
  [ProjectStatuses.CLOSED]: 'Закрыто',
  [ProjectStatuses.CREATED]: 'Создан',
  [ProjectStatuses.QUALIFICATION]: 'Квалификация',
};

export const project_statuses = Object.keys(ProjectStatusesTranslate).map((f: string) => ({
  text: ProjectStatusesTranslate[f],
  value: f,
}));

export enum ProjectStatusesTooltip {
  IDENTIFICATION = 'Проект создан Партнером и находится у ответственного сотрудника АТОЛ на анализе и проверке данных, проверке на дубли',
  QUALIFICATION = 'Начало цикла продаж. Принято решение о закреплении проекта за Партнером. Определены сроки реализации проекта и сумма сделки. Определяем, что решение АТОЛ отвечает задачам конечного клиента.',
  CONFIRMATION = 'Рассмотрение коммерческого предложения от Партнера конечным клиентом',
  EXECUTION = 'Заключительные переговоры, подписание договора поставки с конечным клиентом. Зафиксированы условия оплаты и поставки. На стадии “Исполнение” проект становится доступным для выбора при оформлении корзины',
  WON = 'Заказ на поставку по проекту размещен в ЛКП. Заказ полностью отгружен и оплачен.',
  CLOSED = 'Конечный клиент отказался от  покупки/не принял решение (требует указания причины)',
  FAILED = 'Проект выигран конкурентом (требует указания причины)',
  CREATED = 'Проект находится на согласовании в АТОЛ',
}
